import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { quizSteps } from "../data/quizSteps";
import { useQuiz } from "../hooks/useQuiz";
import { QuizHeader } from "./QuizHeader";
import { StartScreen } from "./StartScreen";
import { NameScreen } from "./NameScreen";
import { QuestionScreen } from "./QuestionScreen";
import { ValueScreen } from "./ValueScreen";
import { LoadingScreen } from "./LoadingScreen";
import { ResultScreen } from "./ResultScreen";
import { Footer } from "./Footer";
import { LegalModal, LegalTab } from "./LegalModal";
const fade = {
  initial: {
    opacity: 0,
    y: 10
  },
  animate: {
    opacity: 1,
    y: 0
  },
  exit: {
    opacity: 0,
    y: -6
  },
  transition: {
    duration: 0.22,
    ease: [0.23, 1, 0.32, 1]
  }
};
export function QuizFunnel() {
  const quiz = useQuiz(quizSteps);
  const [legal, setLegal] = useState<LegalTab | null>(null);
  const progress = quiz.phase === "quiz" ? quiz.answeredCount / quiz.totalQuestions : 0;
  const key = quiz.phase === "quiz" ? quiz.step.id : quiz.phase;
  return <div className="flex min-h-screen w-full flex-col bg-cream text-cocoa" data-id="element-290" data-mp="2mwbjwwg77qg">
      <QuizHeader showProgress={quiz.phase === "quiz"} progress={progress} data-id="element-291" data-mp="3tva6wp9n8nsb" />
      <main className="flex-1" data-id="element-292" data-mp="3ou312vr29yoa">
        <AnimatePresence mode="wait" data-id="element-293" data-mp="3otb4bhlq9uwf">
          <motion.div key={key} {...fade} data-id="element-294" data-mp="3jvt3kehv6lzi">
            {quiz.phase === "start" && <StartScreen onStart={quiz.start} data-id="element-295" data-mp="3jvj9oftp7uoj" />}
            {quiz.phase === "name" && <NameScreen onSubmit={quiz.submitName} data-id="element-296" data-mp="3fuzeviwll35k" />}
            {quiz.phase === "quiz" && quiz.step.kind === "question" && <QuestionScreen step={quiz.step} selected={quiz.answers[quiz.step.id]} onSelect={optionId => quiz.select(quiz.step.id, optionId)} data-id="element-297" data-mp="3b1eghpr3e75u" />}
            {quiz.phase === "quiz" && quiz.step.kind === "value" && <ValueScreen step={quiz.step} name={quiz.name} onContinue={quiz.next} data-id="element-298" data-mp="2w8b7w7vhb3r9" />}
            {quiz.phase === "loading" && <LoadingScreen name={quiz.name} onComplete={quiz.finishLoading} data-id="element-299" data-mp="2hjhztasdv3e9" />}
            {quiz.phase === "result" && <ResultScreen answers={quiz.answers} name={quiz.name} data-id="element-300" data-mp="2micrz3c8q4b1" />}
          </motion.div>
        </AnimatePresence>
      </main>
      <Footer onOpenLegal={setLegal} data-id="element-301" data-mp="28jv517u5svu6" />
      <LegalModal tab={legal} onChangeTab={setLegal} onClose={() => setLegal(null)} data-id="element-302" data-mp="28kwjzneaq2h6" />
    </div>;
}